import React, {
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Button,
  Modal,
  Row,
  Col,
  Layout,
  Card,
  Select,
  DatePicker,
  Table,
  Collapse,
} from "antd";
import {
  ConsoleSqlOutlined,
  DownOutlined,
  FileSearchOutlined,
  EyeOutlined,
  FilterOutlined,
  RedoOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import { ReactSVG } from "react-svg";
import { wrapRequestPayload } from "../../../../helpers/request/RequestPayload";
import {
  getAggregateBdsPublishTopic,
  getAggregateBdsSubscriptionTopic,
  getAdminRolesTopic,
  getProjectsSubscriptionTopic,
  getProjectsRequestPublishTopic,
  getUsersSubscriptionTopic,
  getUserRequestPublishTopic,
  getMemberPageUpdatedPublishTopic,
  getFocusPagePublishTopic,
  getRideInvitationSubscriptionTopic,
} from "hooks/MQTTConstants";
import { useLocation } from "react-router-dom";
import { SocketTopics, UserTopics } from "constants/enums";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { useDispatch } from "react-redux";
import VerticalGraph from "common/Graphs/VerticalGraph";
import useSocketActions from "../../../../hooks/socketActions";
import { generateUUID, popupCenter } from "utils/appUtil";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import { formatForRedis, attributeKeyGenerator } from "utils/appUtil";
import { GET_AGGREGATE, DECRYPT_TOKEN } from "../../../../reducers/reducer";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { throttle, debounce } from "throttle-debounce";
import "../Dashboard/Dashboard.scss";

const { Panel } = Collapse;

ChartJS.register(ArcElement, Tooltip, Legend);

const { Option } = Select;
let typingTimeout;

const RideFilterModal: FC<{
  socket: ISocket;
  params?: any;
  filter?: boolean;
  selected?: string;
  componentUuid?: string;
  onClose?: any;
  phone?: string;
}> = ({ socket, params, filter, selected, componentUuid, onClose, phone }) => {
  const { search } = useLocation();
  const {
    userRequests,
    projects,
    pageAggregateBds,
    selectedPage,
    encrypted_token,
    searchByPhone,
  } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [projectFilter, setProjectFilter] = useState<string>("project");
  const [timeFilter, setTimeFilter] = useState<string>("state");
  const [projectFilterLoading, setProjectFilterLoading] =
    useState<boolean>(false);
  const [projectFilterValue, setProjectFilterValue] = useState<any>(undefined);
  const [timeFilterValue, setTimeFilterValue] = useState<any>(undefined);
  const [statusFilterLoading, setStatusFilterLoading] =
    useState<boolean>(false);
  const [timeFilterLoading, setTimeFilterLoading] = useState<boolean>(false);
  const [projectFilterOptions, setProjectFilterOptions] = useState<any[]>([]);
  const [timeFilterOptions, setTimeFilterOptions] = useState<any[]>([]);
  const [pages, setPages] = useState<any>([]);
  const [pageLocations, setPageLocations] = useState<any>([]);
  const filterUserRequestId = useRef(generateUUID());
  const pageUserRequestId = useRef(generateUUID());
  const startDate = useRef<any>(undefined);
  const endDate = useRef<any>(undefined);
  const pageOffset = useRef<any>(0);
  const selectedColor = useRef<any>(undefined);
  const [pageUpdated, setPageUpdated] = useState<any>();
  const [statusCount, setStatusCount] = useState<any>({
    all: 0,
    live: 0,
    amber: 0,
    purple: 0,
    red: 0,
    green: 0,
    blue: 0,
    grey: 0,
    black: 0,
    brown: 0,
    aqua: 0,
  });
  const [redrawCount, setRedrawCount] = useState<number>(0);
  const [tableDataSource, setTableDataSource] = useState<any>([]);
  const tableDataSourceRef = useRef(undefined);
  const usersRef = useRef(undefined);
  const [tableColumns, setTableColumns] = useState<any>([]);
  const [showTableFilterModal, setShowTableFilterModal] =
    useState<boolean>(false);
  const [tableHideList, setTableHideList] = useState<any>([]);
  const [statusSelected, setStatusSelected] = useState<any>(undefined);
  const { getUserRequestPayload } = useSocketActions();
  const adminRoles = useRef(undefined);
  const pagePaths = useRef({
    project: undefined,
    user: undefined,
    status: undefined,
    area: undefined,
    time: undefined,
    phone: undefined,
  });
  const pageThrottleRef = useRef({});
  const encryptedTokenRef = useRef<any>();

  const loadPaths = useRef<any>([]);

  // const getPageStatusthrottleFunc = throttle(
  //   2000,
  //   (num) => {
  //     console.log('throttle');
  //     getPageStatus();
  //   },
  //   { noLeading: false, noTrailing: false }
  // );

  const setPhonePagePaths = (value) => {
    pagePaths.current.phone = value;

    // ? `exists(@phone) && contains(@phone, '${value}')`
    // : undefined;

    setStatusFilterLoading(true);
    pagePaths.current.status = undefined;
    selectedColor.current = "lime";
    setStatusSelected("lime");
    searchPage();
  };



  const searchPage = (offset = 0) => {
    const expressions = [];
    const load = {};
    if (loadPaths.current) {
      loadPaths.current.map((x) => {
        load[x.key] = x.value;
      });
    }
    pageOffset.current = offset;
    const getPagesRequest = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:page:ride`,
          searchQuery: `@pageMembers:{'${
            encrypted_token?.userId
          }'}(-@rideType:{hail})@pageType:{event}@passengerPhoneNumber:{${formatForRedis(
            pagePaths.current.phone
          )}}`,
          searchOptions: "VERBATIM TIMEOUT 10000",
        },
        load: {
          profile: "$..profile",
          dashboard: "$..dashboard",
          ride: "$.persistent.static.ride",
          dynamic: "$.persistent.dynamic.ride",
          rideType: "$..profile.type",
          pageId: "$.objectId",
          createdAt: "$.persistent.static.metadata.createdAt",
          updatedAt:
            "$.nonpersistent.dynamic.metadata.lastSent.members.updatedAt",
          status: "$.nonpersistent.static.live.status.name",
          phone: "$..dashboard.passengerPhoneNumber",
          ...load,
        },
      },
      filter: {
        expression: expressions.join("&&"),
      },
      sortBy: {
        properties: [
          selected === "advance"
            ? {
                field: "@createdAt",
                order: "ASC",
              }
            : {
                field: "@updatedAt",
                order: "DESC",
              },
        ],
        max: 1000,
      },
      result: pagePaths.current.phone
        ? {
            pagination: {
              offset: offset,
              limit: 50,
            },
          }
        : {},
    };
    dispatch(
      GET_AGGREGATE({
        requestData: getPagesRequest,
        callback: (response) => {
          console.log("resppnse", response);
          setPages(response);
          pageOffset.current = pageOffset.current + 30;
          let sourceData = offset > 0 ? [...tableDataSource] : [];
          let columns: any = [
            {
              title: "Status",
              key: "pageStatus",
              dataIndex: "pageStatus",
              render: (status: string) => (
                <Button className="beam-btn icon-btn ml-2">
                  <ReactSVG
                    src="/images/flag-icon.svg"
                    className={`${status ?? "gray"}-icon`}
                  />
                </Button>
              ),
            },
            {
              title: "Pickup Address",
              key: "address",
              dataIndex: "address",
            },
            {
              title: "Dropoff Address",
              key: "dropoffAddress",
              dataIndex: "dropoffAddress",
            },
            {
              title: "Passenger Name",
              key: "passengerName",
              dataIndex: "passengerName",
            },
            {
              title: "Passenger Phone",
              key: "passengerPhoneNumber",
              dataIndex: "passengerPhoneNumber",
            },
            {
              title: "Driver Name",
              key: "driverName",
              dataIndex: "driverName",
            },
            {
              title: "Vehicle Name",
              key: "vehicleName",
              dataIndex: "vehicleName",
            },
            {
              title: "Fixed Fare",
              key: "fixedFare",
              dataIndex: "fixedFare",
            },
          ];
          response?.map((x, i) => {
            // const profile = x?.profile;
            const profile = {
              ...(x?.profile || {}),
              ...(x?.dashboard || {}),
              ...(x?.ride || {}),
              ...(x?.dynamic || {}),
            };

            const source: any = {};
            Object.keys(profile).map((p) => {
              if (typeof profile[p] === "string") {
                source[p] = profile[p];
              }
            });
            sourceData.push({
              key: x.pageId,
              pageStatus: x.status,
              name: "",
              action: {
                pageId: x.pageId,
                page: {
                  ...x,
                  profile,
                },
                summary: source.summary,
                cudbServiceId: projects?.userServiceId,
              },
              ...source,
              address:
                source?.address && source?.adress !== ""
                  ? source?.address
                  : profile?.pickupLocation?.attributes?.address,
              dropoffAddress:
                source?.dropoffAddress && source?.dropoffAddress !== ""
                  ? source?.dropoffAddress
                  : profile?.dropoffLocation?.attributes?.address,
              invited: "",
            });
          });
          console.log("source data", sourceData);
          sourceData.map((x) => {
            const profile = {
              ...(x?.profile || {}),
              ...(x?.dashboard || {}),
              ...(x?.ride || {}),
              ...(x?.dynamic || {}),
            };
            Object.keys(profile || {}).map((p) => {
              if (
                columns.findIndex((c) => {
                  return c.key === p;
                }) === -1 &&
                typeof profile[p] === "string"
              ) {
              }
            });
          });

          columns.push({
            title: "Action",
            key: "action",
            dataIndex: "action",
            render: (action: any) => (
              <Row style={{ width: 90 }}>
                <Col span={12}>
                  <Button
                    className="beam-btn icon-btn"
                    onClick={() => {
                      popupCenter(
                        `${process.env.REACT_APP_WEB}/page/${action?.pageId}`,
                        "BeamLive",
                        window.innerWidth * 0.7,
                        window.innerHeight * 0.9
                      );
                    }}
                  >
                    <MessageOutlined />
                  </Button>
                </Col>

                <Col span={12}>
                  {action?.summary && (
                    <Button
                      className="beam-btn icon-btn ml-2"
                      onClick={() => {
                        // const query = new URLSearchParams(search);
                        // const connectionId = query.get("connectionId");
                        window.open(
                          `${window.location.origin}/${
                            action?.summary ?? "summary"
                          }?connectionId=${
                            encrypted_token?.connectionId
                          }&pageId=${action?.pageId}&cudbServiceId=${
                            action?.cudbServiceId
                          }`,
                          "_blank"
                        );
                      }}
                    >
                      <FileSearchOutlined />
                    </Button>
                  )}
                </Col>
              </Row>
            ),
          });
          setTableColumns(columns);

          console.log("set source date", sourceData);
          setTableDataSource(sourceData);
          tableDataSourceRef.current = sourceData;
          setPageLocations(
            response?.map((x) => {
              return {
                lat: x?.persistent?.static?.live?.location?.coordinates?.lat,
                lng: x?.persistent?.static?.live?.location?.coordinates.long,
                title: x?.persistent?.static?.metadata?.title,
              };
            })
          );
          setStatusFilterLoading(false);
          setProjectFilterLoading(false);
          setTimeFilterLoading(false);
        },
      })
    );
    // getPageStatus();
    // getPageStatusthrottleFunc();
  };

  useEffect(() => {
    if (encrypted_token) {
      // const query = new URLSearchParams(search);
      // const userId = query.get("userId");
      // const connectionId = query.get("connectionId");
      encryptedTokenRef.current = encrypted_token;

      setProjectFilterLoading(true);
      // searchPage();

      setPhonePagePaths(phone);

      // setTableHideList(JSON.parse(localStorage.getItem("tableHideList")) || []);
    }
  }, [encrypted_token]);

  useEffect(() => {
    if (projects) {
      // const query = new URLSearchParams(search);
      // const connectionId = query.get("connectionId");
      const options = [];
      projects?.projects?.map((project) => {
        options.push({ label: project.name, value: project.id });
      });
      setProjectFilterOptions(options);
    }
  }, [projects]);

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const handleOk = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  return (
    <React.Fragment>
      <Modal
        title="Search"
        visible={isModalVisible}
        onCancel={handleCancel}
        width="1000px"
        bodyStyle={{ height: 600 }}
        className="beam-modal analytics-summary-modal"
        footer={[]}
        destroyOnClose={true}
      >
        <Row
          gutter={20}
          className="scrollable-table"
          style={{
            display: "grid",
            transformOrigin: "0px 0px",
            transform: "scale(0.8)",
            width: "125%",
          }}
        >
          <Col
            xs={24}
            sm={24}
            md={24}
            style={{ maxHeight: 1000, overflow: "scroll" }}
          >
            <Table
              dataSource={tableDataSource}
              className={tableDataSource?.length > 0 ? "" : "table-empty-1"}
              onRow={(record) => {
                return {
                  onDoubleClick: () => {
                    console.log("on double click row", record);
                  },
                  onClick: () => {
                    dispatch({
                      type: "SET_SELECTED_PAGE",
                      payload: { page: record?.action?.page, ignorePage: true },
                    });
                  },
                };
              }}
              columns={tableColumns}
              scroll={{ x: true }}
              onChange={(e) => {
                console.log("event here", e);
              }}
              rowClassName={(record, index) => {
                if (record?.key === selectedPage?.page?.pageId)
                  return "row-selected";
                return "";
              }}
            />
          </Col>
        </Row>
      </Modal>
    </React.Fragment>
  );
};

export default RideFilterModal;
